/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Edit: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.6005 3.70238C14.7712 2.53334 16.6673 2.53272 17.8388 3.701L19.2916 5.1499C20.4647 6.31979 20.4674 8.2191 19.2976 9.3923L18.2127 10.4804L18.2115 10.4817L11.01 17.7309L11.0097 17.7312C10.4713 18.2726 9.80269 18.6667 9.06813 18.8761L5.37931 19.9271C3.97769 20.3265 2.67038 19.0339 3.07447 17.6234L4.13055 13.9372C4.33902 13.2095 4.72994 12.5471 5.26611 12.0124L5.26627 12.0122L12.5092 4.79213L12.5099 4.79151L13.6005 3.70238ZM17.5013 8.3613L17.8813 7.98017C18.2712 7.5891 18.2704 6.956 17.8793 6.56603L16.4265 5.11713C16.036 4.7277 15.404 4.72791 15.0137 5.11759L14.6315 5.49927L17.5013 8.3613ZM13.2157 6.91188L6.67841 13.4285C6.67835 13.4285 6.6783 13.4286 6.67825 13.4287C6.38283 13.7233 6.16781 14.0879 6.0532 14.488L5.06508 17.9371L8.52006 16.9526C8.92569 16.837 9.29445 16.6196 9.59111 16.3213C9.59113 16.3213 9.59115 16.3213 9.59118 16.3213C9.59127 16.3212 9.59135 16.3211 9.59144 16.321L16.0905 9.77888L13.2157 6.91188Z'
      fill='currentColor'
    />
  </React.Fragment>
)
